import { render, staticRenderFns } from "./journalist.vue?vue&type=template&id=05f19fde&scoped=true"
import script from "./journalist.vue?vue&type=script&lang=js"
export * from "./journalist.vue?vue&type=script&lang=js"
import style0 from "./journalist.vue?vue&type=style&index=0&id=05f19fde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f19fde",
  null
  
)

export default component.exports